<script>
import Swal from 'sweetalert2';
import { Confirm } from '../../services/Confirm';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';

export default {
  components: {
    BDropdown,
    BDropdownItem,
  },

  props: ['user', 'mail'],

  data () {
    return {
      open: false,
      saving: false,
    };
  },

  mounted () {
    Bus.$on('mailContentSaved', () => this.saving = false);
  },

  methods: {
    async changeToBee () {
      const title = this.__('Deseja realmente continuar?');
      const text = this.__('Você irá perder todos os dados desta edição ao mudar de editor.');

      if (! await Confirm(title, text)) {
        return;
      }

      this.$http.put(`/mail/${mail.id}`, { edit_as_visual: true })
        .then(({ data }) => window.location = `/mail/${data.id}/builder`)
        .catch((error) => console.warn(error));
    },

    async createAutomation () {
      if (! await Confirm(this.__('Criar nova campanha com este modelo de e-mail?'))) {
        return;
      }

      this.$http.post(`/automation/mail/${this.mail.id}`)
        .then(({ data }) => window.open(`/automation/${data.id}`));
    },

    save () {
      this.saving = true;
      Bus.$emit('saveEditorContent');
      Alert.setModalOpen(true);

      Swal.fire({
        icon: 'success',
        title: this.__('Seu conteúdo foi salvo!'),
        text: this.__('Deseja enviar este e-mail agora?'),
        width: 350,
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: this.__('Enviar agora'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Salvar para enviar mais tarde'),
        showCancelButton: true,
        customClass: {
          container: 'container-swal2',
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
        },
        toast: false,
        timer: null,
      }).then((result) => {
        Alert.setModalOpen(false);
        if (result.dismiss !== 'cancel') {
          this.send();
        }
        Alert.success(this.__('Conteúdo salvo com sucesso!'), 'bottom-end');
      });
    },

    send () {
      this.$http.get(`/automation/mail/${this.mail.id}`)
        .then(({ data }) => {
          window.location = `/automation/${data.id}#sending`;
        })
        .catch(() => {
          console.warn(this.__('Não foi possivel enviar o email!'));
          Alert.error(this.__('Não foi possivel enviar o email!'));
        });
    },
  },
};
</script>

<template>
  <section
    class="mail"
  >
    <div
      class="row"
    >
      <div
        class="col-12 pl-30px d-flex align-items-center"
      >
        <h2
          class="page-subtitle"
          v-text="mail.title || 'Modelo sem título'"
        />

        <MailAction
          class="ml-auto"
          :user="user"
          :mail="mail"
        />
      </div>

      <div
        class="col-12"
      >
        <div
          class="builder-header d-flex align-items-center mt-4"
        >
          <img
            class="bee-logo pr-2"
            height="39"
            src="https://app.getbee.io/nl/v19.04.29.1450.1/assets/6d113bcf.svg"
            alt=""
          >

          <ul
            class="nav"
            :class="{
              open,
            }"
          >
            <li
              class="nav-item dropdown"
            >
              <BDropdown
                no-caret
                variant="link"
                @show="open = true"
                @hide="open = false"
                class="nav-action nav-profile"
                menu-class="bdk-mail-show__dropdown"
                toggle-class="text-decoration-none p-0"
              >
                <template #button-content>
                  <a
                    href="#"
                    role="button"
                    class="nav-link"
                  >
                    {{ __('Ações') }}

                    <IconChevron
                      class="bdk-rotate-90 bdk-ml-2 bdk-transition-all"
                      :class="{
                        'bdk--rotate-90': open,
                      }"
                    />
                  </a>
                </template>

                <BDropdownItem
                  href="#"
                  @click.prevent="createAutomation()"
                >
                  {{ __('Criar Campanha') }}
                </BDropdownItem>

              </BDropdown>
            </li>
          </ul>

          <button
            type="button"
            :disabled="saving"
            @click.prevent="save()"
            class="btn btn-bee ml-auto"
          >
            <span
              v-if="saving"
              v-text="__('Salvando...')"
            />

            <span
              v-else
              v-text="__('Salvar')"
            />
          </button>
        </div>

        <MailSend
          :user="user"
          :id="mail.id"
        />

        <MailConfig
          :user="user"
          :mail="mail"
        />

        <MailEditor
          :user="user"
          :mail="mail"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scopped>
  @import '../../../sass/variables';

  .mail {
    .builder-header {
      background-color: $gray-mako;
      width: 100%;
      padding: 0 20px;
      border-radius: 15px 15px 0 0;

      .btn {
        font-size: 0.75rem;
        font-weight: 700;
        line-height: 1.42857;
        border: 1px solid transparent;
        white-space: nowrap;
        touch-action: manipulation;
      }

      .btn-bee {
        min-width: 100px;
        color: $white;
        background-color: #4cb9ea;
        border-color: #35b0e7;
        margin: 12px 0;
        padding: 6px 12px;
        border-radius: 5px;
        text-transform: uppercase;

        &:hover {
          background-color: #1ea7e5;
          border-color: #1791c8;
        }
      }

      .nav {
        &.open {
          background: #32373a;
        }

        .nav-item {
          padding: 15px 0;

          &.nav-right {
            padding: 12px;
          }

          &:not(:first-child) .nav-link {
            border-left: 1px solid #6d6d6d;
          }

          .nav-link {
            color: #fff;
            font-size: 12px;
            font-weight: 400;
            padding: 2px 25px;
          }

          .btn-primary {
            color: #fff;
            text-align: center;
            background-color: #4cb9ea;
            padding: 6px 12px 8px;
            font-size: 12px;
            font-weight: 700;
            line-height: 1.42857;
            -webkit-border-radius: 4px;
            border-radius: 4px;
            border-color: #35b0e7;
            display: inline-block;
            margin-right: 6px;
            min-width: 100px;
            vertical-align: baseline;
          }
        }
      }
    }
  }
</style>
